import { render, staticRenderFns } from "./NLDataTable.vue?vue&type=template&id=16c2a9bf&scoped=true"
import script from "./NLDataTable.vue?vue&type=script&lang=js"
export * from "./NLDataTable.vue?vue&type=script&lang=js"
import style0 from "./NLDataTable.vue?vue&type=style&index=0&id=16c2a9bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c2a9bf",
  null
  
)

export default component.exports